import React, { Fragment } from 'react';
import _ from 'lodash';
import { Item, Grid, Icon, Card, Divider, Segment } from 'semantic-ui-react';

import mapConnection from '../../../utils/connectionMapper';
import ClaimInformation from './ClaimInformation';
import Comments from './Comments';
import ButtonsBlock from './ButtonsBlock';
import StateTransition from './StateTransition';
import Compensation from './Compensation';
import Flights from './Flights';
import Passengers from './Passengers';
import Litigation from './Litigation';
import Amicable from './Amicable';

const ClaimDetails = ({
  claim,
  claim: {
    id,
    crmState,
    codeClaim,
    createdAt,
    updatedAt,
    iban,
    bicSwift,
    paxPaypalId,
    paxTransferChannel,
    passengerTicket,
    passengerTicketId,
    reason,
    reasonForAbandon,
    totalDelay,
    magicKey,
    travelerFormUrl,
    testimonialUrl,
    paymentUrl,
    flightId,
    affiliate,
    airlineCustomerServiceEmail,
    flight,
    refundFromAirlineAmount,
    refundFromAirlineDate,
    refundToPaxAmount,
    refundToPaxDate,
    passengerComment,
    commentsConnection,
    flightsPassengerTicketsConnection,
    claimsPassengerTicketConnection,
    refundFromLawyerAmountForPax,
    refundFromLawyerLegalFeesAmount,
    paxBankAccountHolder,
    donatedAmount,
    paxCompensationAmount,
    maximumCompensationAmount,
    paxToTransferAmount
  },
  previewOnly,
  onClaimUpdated,
  hideLoading,
  showLoading
}) => {
  const passengerAmount = _.get(claimsPassengerTicketConnection, 'edges', [])
    .length;
  const comments = mapConnection(commentsConnection) || [];
  const flights = mapConnection(flightsPassengerTicketsConnection) || [];
  const claimsPassengerTickets =
    mapConnection(claimsPassengerTicketConnection) || [];

  const commonProps = {
    id,
    crmState,
    onClaimUpdated,
    hideLoading,
    showLoading
  };

  const claimInformationData = {
    createdAt,
    updatedAt,
    crmState,
    reason,
    reasonForAbandon,
    totalDelay,
    magicKey,
    travelerFormUrl,
    testimonialUrl,
    paymentUrl,
    passengerTicket
  };

  const commentsData = {
    comments,
    passengerComment,
    passengerTicket,
    ...commonProps
  };

  const compensationData = {
    refundFromAirlineAmount,
    refundFromAirlineDate,
    refundToPaxAmount,
    refundToPaxDate,
    refundFromLawyerAmountForPax,
    refundFromLawyerLegalFeesAmount,
    ...commonProps
  };

  const flightsData = {
    flight,
    flights,
    passengerTicketId,
    previewOnly,
    ...commonProps
  };

  const passengersData = {
    flightId,
    affiliate,
    passengerAmount,
    passengerTicketId,
    claimsPassengerTickets,
    previewOnly,
    paxBankAccountHolder,
    donatedAmount,
    paymentData: {
      iban,
      bicSwift,
      paxPaypalId,
      paxTransferChannel
    },
    ...commonProps
  };

  const amicableBlockData = {
    crmState,
    paxCompensationAmount,
    maximumCompensationAmount,
    refundFromAirlineDate,
    refundFromAirlineAmount,
    paxToTransferAmount
  };
  return (
    <Segment basic>
      <Card fluid>
        <Card.Content textAlign='left'>
          <Card.Header>
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <Icon
                    name={`user${passengerAmount === 1 ? '' : 's'}`}
                    size='large'
                  />
                  {codeClaim}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Header>
          <Item.Group>
            <ClaimInformation {...claimInformationData} />
            <Divider />
            {flight.airline ? (
              <Fragment>
                <Comments {...commentsData} />
                <Divider hidden />
                <ButtonsBlock
                  airlineCustomerServiceEmail={
                    airlineCustomerServiceEmail
                  }
                  {...commonProps}
                />
                <Divider />
                {!previewOnly && (
                  <Fragment>
                    <StateTransition {...commonProps} />
                    <Divider />
                    <Compensation {...compensationData} />
                  </Fragment>
                )}
                <Divider />
                {flight && <Flights {...flightsData} />}
                {crmState.startsWith('c') && <Litigation {...claim} />}
                {(crmState === 'b5_pax_to_refund' ||
                  crmState.startsWith('b4')) && (
                  <Amicable {...amicableBlockData} />
                )}
                <Passengers {...passengersData} />
              </Fragment>
            ) : (
              <Flights {...flightsData} />
            )}
          </Item.Group>
        </Card.Content>
      </Card>
    </Segment>
  );
};

export default ClaimDetails;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/index.js